import React from "react";

import { HelmetProvider } from "@bluefin/components";

const context = {};

export const wrapRootElement = ({ element }) => {
  return <HelmetProvider context={context}>{element}</HelmetProvider>;
};
